<template>
	<div class="fireDom">
		<MoveBox v-for="item in active" :key="item.decisionId" :ifTime="true">
			<div class="controlDom">
				<div class="title-top">
					<div style="display: flex;">
						<img src="../../static/imgV2/detail-title.png" alt="">
						<div class="title-top-text">灭火处置</div>
					</div>
					<div class="fireCount" :class="{fireCountWarn: expired(item)}">{{ remainText(item) }}</div>
				</div>

				<div class="fireTabs" v-if="canShowControl(item)">
					<div class="fireTab" :class="{fireTabDo: item.tab == 'info'}" @click="switchTab(item, 'info')">处置</div>
					<div class="fireTab" :class="{fireTabDo: item.tab == 'ctrl'}" @click="switchTab(item, 'ctrl')">操控</div>
				</div>

				<div class="fireInfo" v-if="!item.tab || item.tab == 'info'">
					<div class="fireRow">
						<span class="fireLabel">机器人</span>
						<span class="fireValue">{{ robotLabel(item) }}</span>
					</div>
					<div class="fireRow">
						<span class="fireLabel">火情来源</span>
						<span class="fireValue">{{ sourceText(item) }}</span>
					</div>

					<div class="fireImgDom">
						<div class="fireImg">
							<img v-if="item.snapshotUrl" :src="item.snapshotUrl" alt="">
							<div v-else class="fireNoImg">无图片</div>
							<div class="fireImgName">可见光</div>
						</div>
						<div class="fireImg">
							<img v-if="item.thermalUrl" :src="item.thermalUrl" alt="">
							<div v-else class="fireNoImg">无图片</div>
							<div class="fireImgName">热成像</div>
						</div>
					</div>

					<div class="fireRow">
						<span class="fireLabel">最高温度</span>
						<span class="fireValue">{{ item.maxTemp == null ? '未知' : item.maxTemp + ' ℃' }}</span>
					</div>
					<div class="fireRow">
						<span class="fireLabel">任务</span>
						<span class="fireValue">{{ emptyText(item.taskId) }}</span>
					</div>
					<div class="fireRow">
						<span class="fireLabel">点位</span>
						<span class="fireValue">{{ emptyText(item.pointId) }}</span>
					</div>
					<div class="fireRow">
						<span class="fireLabel">无操作剩余</span>
						<span class="fireValue">{{ remainText(item) }}</span>
					</div>

					<div class="fireApplied">{{ appliedText(item) }}</div>
					<div class="fireState" v-if="item.resultNote">{{ item.resultNote }}</div>
					<div class="fireState" v-else-if="!connected">连接异常，状态待确认</div>
					<div class="fireState" v-else-if="expired(item)">等待平台超时确认</div>

					<div class="fireBtnDom">
						<div class="btn1 btnDo" :class="{btnDis: locked(item)}" @click="apply(item, 'START')">开始灭火</div>
						<div class="btn1 btnDo" :class="{btnDis: locked(item)}" @click="apply(item, 'STOP')">结束灭火</div>
						<div class="btn1" :class="{btnDis: locked(item)}" @click="apply(item, 'END')">提前结束</div>
					</div>
				</div>

				<div class="fireCtrl" v-else>
					<div class="fireCtrlTip" v-if="!timeEnd">未持有控制权，底盘操作无效</div>

					<div class="fireCtrlBox">
						<div class="control-title">云台</div>
						<div class="fireCtrlBody">
							<div class="fireCtrlPad">
								<img class="fireCtrlImgL" :src="pTZImg_t" @mousedown="press('ptz', 'top', true)" @mouseup="press('ptz', 'top', false)" alt="">
								<div>
									<img class="fireCtrlImgS" :src="pTZImg_l" @mousedown="press('ptz', 'left', true)" @mouseup="press('ptz', 'left', false)" alt="">
									<img class="fireCtrlImgS" :src="pTZImg_r" @mousedown="press('ptz', 'right', true)" @mouseup="press('ptz', 'right', false)" alt="">
								</div>
								<img class="fireCtrlImgL" :src="pTZImg_b" @mousedown="press('ptz', 'bottom', true)" @mouseup="press('ptz', 'bottom', false)" alt="">
							</div>
							<div class="fireCtrlBtn" @click="ptzReset()">云台复位</div>
						</div>
					</div>

					<div class="fireCtrlBox">
						<div class="control-title">升降杆</div>
						<div class="fireCtrlBody">
							<div class="fireCtrlPad">
								<img class="fireCtrlImgL" :src="rodImg_t" @mousedown="press('rod', 'top', true)" @mouseup="press('rod', 'top', false)" alt="">
								<img class="fireCtrlImgL" :src="rodImg_b" @mousedown="press('rod', 'bottom', true)" @mouseup="press('rod', 'bottom', false)" alt="">
							</div>
							<div class="fireCtrlName">上 / 下</div>
						</div>
					</div>

					<div class="fireCtrlBox" v-if="['04', '05', '06', '07'].includes(robotInfo.robotType)">
						<div class="control-title">底盘</div>
						<div class="fireCtrlBody">
							<div class="fireCtrlPad">
								<img class="fireCtrlImgS" :src="positionImg_t" @mousedown="press('robot', 'top', true)" @mouseup="press('robot', 'top', false)" alt="">
								<div>
									<img class="fireCtrlImgS" :src="positionImg_l" @mousedown="press('robot', 'left', true)" @mouseup="press('robot', 'left', false)" alt="">
									<img class="fireCtrlImgS" :src="positionImg_b" @mousedown="press('robot', 'bottom', true)" @mouseup="press('robot', 'bottom', false)" alt="">
									<img class="fireCtrlImgS" :src="positionImg_r" @mousedown="press('robot', 'right', true)" @mouseup="press('robot', 'right', false)" alt="">
								</div>
							</div>
							<div class="fireCtrlName">前进 / 后退 / 左转 / 右转</div>
						</div>
					</div>

					<div class="fireCtrlBox" v-else>
						<div class="control-title">底盘</div>
						<div class="fireCtrlBody">
							<div class="fireCtrlPad">
								<img class="fireCtrlImgS" :src="positionImg_t" @mousedown="press('robot', 'top', true)" @mouseup="press('robot', 'top', false)" alt="">
								<div>
									<img class="fireCtrlImgS" :src="positionImg_l" @mousedown="press('robot', 'left', true)" @mouseup="press('robot', 'left', false)" alt="">
									<img class="fireCtrlImgS" :src="positionImg_b" @mousedown="press('robot', 'bottom', true)" @mouseup="press('robot', 'bottom', false)" alt="">
									<img class="fireCtrlImgS" :src="positionImg_r" @mousedown="press('robot', 'right', true)" @mouseup="press('robot', 'right', false)" alt="">
								</div>
							</div>
							<div class="fireCtrlSpeed">
								<el-radio v-model="radioValue" label="1">正常</el-radio>
								<el-radio v-model="radioValue" label="2">低速</el-radio>
							</div>
						</div>
					</div>
				</div>
			</div>
		</MoveBox>
	</div>
</template>

<script>
	import MoveBox from '@/components/MoveBox.vue'
	import {
		firefightingDecision
	} from '@/api/indexV2.js'
	import {
		angleControl,
		rodControl,
		control,
		deControl
	} from '@/api/admin.js'
	import {
		getItem
	} from '@/utils/auth'

	export default {
		name: 'FirefightingDialog',
		components: {
			MoveBox
		},
		props: {
			robotId: String,
			robotInfo: Object,
			timeEnd: Boolean,
			connected: Boolean
		},
		data() {
			return {
				active: [],
				// 终态留痕跨重连保留，防止后到的 CONFIRM 复活已关闭的弹框
				closed: {},
				submitting: {},
				now: Date.now(),
				// 消息生成时间减本地时间，用于抵消两端时钟差；只取非负值，传输延迟只会让估计偏保守
				serverOffset: 0,
				timer: null,
				ptzTimer: null,
				rodTimer: null,
				chassisTimer: null,
				radioValue: '1',
				positionImg_t: require('../../static/imgV2/w.png'),
				positionImg_l: require('../../static/imgV2/a.png'),
				positionImg_r: require('../../static/imgV2/d.png'),
				positionImg_b: require('../../static/imgV2/s.png'),
				positionImg_top: require('../../static/imgV2/w.png'),
				positionImg_left: require('../../static/imgV2/a.png'),
				positionImg_right: require('../../static/imgV2/d.png'),
				positionImg_bottom: require('../../static/imgV2/s.png'),
				positionImg_top_check: require('../../static/imgV2/w-check.png'),
				positionImg_left_check: require('../../static/imgV2/a-check.png'),
				positionImg_right_check: require('../../static/imgV2/d-check.png'),
				positionImg_bottom_check: require('../../static/imgV2/s-check.png'),
				pTZImg_t: require('../../static/imgV2/top.png'),
				pTZImg_l: require('../../static/imgV2/left.png'),
				pTZImg_r: require('../../static/imgV2/right.png'),
				pTZImg_b: require('../../static/imgV2/bottom.png'),
				pTZImg_top: require('../../static/imgV2/top.png'),
				pTZImg_left: require('../../static/imgV2/left.png'),
				pTZImg_right: require('../../static/imgV2/right.png'),
				pTZImg_bottom: require('../../static/imgV2/bottom.png'),
				pTZImg_top_check: require('../../static/imgV2/top-check.png'),
				pTZImg_left_check: require('../../static/imgV2/left-check.png'),
				pTZImg_right_check: require('../../static/imgV2/right-check.png'),
				pTZImg_bottom_check: require('../../static/imgV2/bottom-check.png'),
				rodImg_t: require('../../static/imgV2/top.png'),
				rodImg_b: require('../../static/imgV2/bottom.png'),
				ifPTZTop: false,
				ifPTZLeft: false,
				ifPTZRight: false,
				ifPTZBottom: false,
				ifRodTop: false,
				ifRodBottom: false,
				ifpositionTop: false,
				ifpositionLeft: false,
				ifpositionRight: false,
				ifpositionBottom: false,
				constTop: null,
				constLeft: null,
				postionTop: null,
				postionLeft: null
			}
		},
		mounted() {
			this.timer = setInterval(() => {
				if (!this.active.length) return
				this.now = Date.now()
			}, 1000)
		},
		beforeDestroy() {
			clearInterval(this.timer)
			this.clearTimers()
		},
		methods: {
			handleMessage(socketData) {
				if (String(socketData.socketType) !== '52' || String(socketData.cmd) !== '11100') return
				let decisionId = socketData.decisionId
				if (!decisionId) return

				let event = socketData.firefightingEvent
				let isTerminal = event === 'CLOSE' || event === 'TIMEOUT'
				let session = this.find(decisionId)

				// 终态优先于后到的非终态消息与 HTTP 非终态成功响应，不允许复活同一弹框
				if (this.closed[decisionId] && !isTerminal) return
				// 非终态消息只应用更高版本，同版本重复投递不新建弹框也不改倒计时
				if (!isTerminal && session && Number(socketData.version) <= session.version) return

				// 传输只会让本地时间落后，所以偏差取非负
				if (socketData.timestamp) this.serverOffset = Math.max(0, socketData.timestamp - Date.now())

				if (isTerminal) {
					this.closeSession(socketData)
					return
				}

				if (!session) {
					session = {
						decisionId,
						deviceSn: socketData.deviceSn,
						robotId: socketData.robotId,
						version: Number(socketData.version) || 0,
						appliedAction: null,
						resultNote: null,
						tab: 'info',
						snapshotUrl: null,
						thermalUrl: null
					}
					this.active.push(session)
				}
				session.deviceSn = socketData.deviceSn || session.deviceSn
				session.robotId = socketData.robotId || session.robotId
				session.version = Number(socketData.version) || session.version
				session.expireTimestamp = socketData.expireTimestamp
				session.timeoutMs = socketData.timeoutMs
				if (socketData.appliedAction !== undefined) session.appliedAction = socketData.appliedAction

				// 只有 CONFIRM 携带现场信息，ACTION/RENEW 不覆盖已有图片与温度
				if (event === 'CONFIRM') {
					session.fireDetected = socketData.fireDetected
					session.alarmSource = socketData.alarmSource
					session.taskId = socketData.taskId
					session.pointId = socketData.pointId
					session.maxTemp = socketData.maxTemp
					session.snapshotUrl = socketData.snapshotUrl
					session.thermalUrl = socketData.thermalUrl
				}
			},
			find(decisionId) {
				return this.active.find(item => item.decisionId === decisionId)
			},
			closeSession(socketData) {
				let decisionId = socketData.decisionId
				this.$set(this.closed, decisionId, {
					version: Number(socketData.version) || 0,
					event: socketData.firefightingEvent
				})
				this.active = this.active.filter(item => item.decisionId !== decisionId)
				this.releaseAll()
				this.$set(this.submitting, decisionId, null)
				this.$notify({
					title: '灭火处置',
					message: this.closeText(socketData),
					type: 'info',
					duration: 5000
				})
			},
			closeText(socketData) {
				if (socketData.firefightingEvent === 'TIMEOUT') return '三分钟无有效操作，平台已发起提前结束'
				if (socketData.reason === 'ROBOT_TIMEOUT') return '机器人无操作超时，已自主退出处置'
				return '本次处置已提前结束'
			},
			switchTab(item, tab) {
				if (item.tab === tab) return
				this.releaseAll()
				this.$set(item, 'tab', tab)
			},
			canShowControl(item) {
				return !!item.robotId && item.robotId === this.robotId && !!this.robotInfo && !!this.robotInfo.number
			},
			expired(item) {
				return !!item.expireTimestamp && this.remainMs(item) <= 0
			},
			remainMs(item) {
				if (!item.expireTimestamp) return null
				return item.expireTimestamp - (this.now + this.serverOffset)
			},
			remainText(item) {
				let ms = this.remainMs(item)
				if (ms === null) return '未知'
				if (ms <= 0) return '已到时'
				let total = Math.ceil(ms / 1000)
				let minute = Math.floor(total / 60)
				let second = total % 60
				return (minute < 10 ? '0' + minute : minute) + ':' + (second < 10 ? '0' + second : second)
			},
			// 提交期间、本地到时、信令断连都不允许再发起命令；到时也不自行下发 END
			locked(item) {
				if (!this.connected) return true
				if (this.expired(item)) return true
				return !!this.submitting[item.decisionId]
			},
			robotLabel(item) {
				if (this.robotInfo && this.robotInfo.robotName && item.robotId === this.robotId) {
					return this.robotInfo.robotName + '（' + item.deviceSn + '）'
				}
				return item.deviceSn || '未知'
			},
			sourceText(item) {
				if (item.alarmSource === 'FLAME') return '火焰识别'
				return item.alarmSource || '未知'
			},
			emptyText(value) {
				return value === null || value === undefined || value === '' ? '未知' : value
			},
			appliedText(item) {
				let action = this.submitting[item.decisionId] || item.appliedAction
				if (action === 'START') return '最近受理操作：已受理开始灭火命令'
				if (action === 'STOP') return '最近受理操作：已受理结束灭火命令'
				if (action === 'END') return '最近受理操作：已受理提前结束命令'
				return '最近受理操作：暂无操作'
			},
			apply(item, action) {
				if (this.locked(item)) return
				if (action === 'START') {
					this.$confirm('确认向机器人下发开始灭火命令？', '开始灭火', {
						confirmButtonText: '确认下发',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.submit(item, action)
					}).catch(() => {})
					return
				}
				this.submit(item, action)
			},
			submit(item, action) {
				let decisionId = item.decisionId
				if (this.submitting[decisionId]) return
				this.$set(this.submitting, decisionId, action)
				item.resultNote = null
				let userInfo = getItem('userInfo') || {}
				firefightingDecision(item.deviceSn, {
					decisionId,
					// 同一次操作的网络重试必须复用同一个 requestId，故只在提交时生成一次
					requestId: this.uuid(),
					action,
					operator: userInfo.account
				}).then(res => {
					this.$set(this.submitting, decisionId, null)
					let data = res && res.data
					if (!data || !data.accepted) {
						item.resultNote = '本次命令结果未知，请人工确认'
						return
					}
					// HTTP 响应与信令消息可能乱序到达，已终结或已有更高版本时不回头改状态
					if (this.closed[decisionId]) return
					if (data.version && data.version < item.version) return
					item.appliedAction = data.appliedAction || action
					if (data.terminal) {
						this.closeSession({
							firefightingEvent: 'CLOSE',
							reason: 'MANUAL_END',
							version: data.version,
							decisionId
						})
						return
					}
					item.resultNote = null
					if (data.expireTimestamp) item.expireTimestamp = data.expireTimestamp
				}).catch(() => {
					// 业务码被全局拦截器吞掉，无法区分超时/冲突/链路不可用，只按结果未知处理且不自动重试
					this.$set(this.submitting, decisionId, null)
					item.resultNote = '本次命令结果未知，请人工确认'
				})
			},
			uuid() {
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
					let r = Math.random() * 16 | 0
					return (c === 'x' ? r : (r & 3 | 8)).toString(16)
				})
			},
			press(kind, value, status) {
				if (kind === 'ptz') {
					if (value === 'top') this.ifPTZTop = status
					else if (value === 'left') this.ifPTZLeft = status
					else if (value === 'right') this.ifPTZRight = status
					else this.ifPTZBottom = status
					return
				}
				if (kind === 'rod') {
					if (value === 'top') this.ifRodTop = status
					else this.ifRodBottom = status
					return
				}
				// 底盘沿用现有逻辑，未持有控制权时不响应
				if (!this.timeEnd) return
				if (value === 'top') this.ifpositionTop = status
				else if (value === 'left') this.ifpositionLeft = status
				else if (value === 'right') this.ifpositionRight = status
				else this.ifpositionBottom = status
			},
			clearTimers() {
				clearInterval(this.ptzTimer)
				clearInterval(this.rodTimer)
				clearInterval(this.chassisTimer)
				this.ptzTimer = null
				this.rodTimer = null
				this.chassisTimer = null
			},
			releaseAll() {
				this.ifPTZTop = this.ifPTZLeft = this.ifPTZRight = this.ifPTZBottom = false
				this.ifRodTop = this.ifRodBottom = false
				this.ifpositionTop = this.ifpositionLeft = this.ifpositionRight = this.ifpositionBottom = false
			},
			postData() {
				return {
					number: this.robotInfo.number,
					tenantInfoId: getItem('tenantInfoId')
				}
			},
			ptzReset() {
				angleControl(Object.assign(this.postData(), {
					direction: '-1'
				})).then(() => {})
			},
			// 云台方向合成，方向编码与既有遥控面板完全一致
			ptzAngle(type, value) {
				this.ptzTimer && clearInterval(this.ptzTimer)
				let direction = '0'
				this.constTop = this.constTop ? this.constTop : '0'
				this.constLeft = this.constLeft ? this.constLeft : '0'
				if (value) {
					if (type == '1') {
						if (this.constTop == '0') this.constTop = '1'
						else return false
					} else if (type == '2') {
						if (this.constLeft == '0') this.constLeft = '1'
						else return false
					} else if (type == '3') {
						if (this.constLeft == '0') this.constLeft = '2'
						else return false
					} else if (type == '4') {
						if (this.constTop == '0') this.constTop = '2'
						else return false
					}
				} else {
					if (type == '1' || type == '4') {
						if (this.constTop == '0') return false
						this.constTop = '0'
					} else if (type == '2' || type == '3') {
						if (this.constLeft == '0') return false
						this.constLeft = '0'
					}
				}

				if (this.constTop == '1') {
					if (this.constLeft == '1') direction = '5'
					else if (this.constLeft == '2') direction = '6'
					else direction = '1'
				} else if (this.constTop == '2') {
					if (this.constLeft == '1') direction = '8'
					else if (this.constLeft == '2') direction = '7'
					else direction = '2'
				} else if (this.constTop == '0') {
					if (this.constLeft == '1') direction = '3'
					else if (this.constLeft == '2') direction = '4'
					else direction = '0'
				}
				angleControl(Object.assign(this.postData(), {
					direction
				})).then(() => {})
			},
			// 升降杆：按住期间 300ms 轮询，松开补发停止
			rodAngle(type, value) {
				this.rodTimer && clearInterval(this.rodTimer)
				let direction = '0'
				if (value) direction = type == '1' ? '1' : '2'
				let ajaxPost = Object.assign(this.postData(), {
					direction
				})
				if (direction != '0') {
					this.rodTimer = setInterval(() => {
						rodControl(ajaxPost).then(() => {})
					}, 300)
				} else {
					rodControl(ajaxPost).then(() => {})
				}
			},
			// 底盘：室外机走单方向轮询，室内机合成斜向，与既有遥控面板一致
			chassisMove(type, value) {
				this.chassisTimer && clearInterval(this.chassisTimer)
				if (['01', '02', '08', '09'].includes(this.robotInfo.robotType)) {
					let ajaxPost = {
						number: this.robotInfo.number,
						direction: type,
						terminal: '1',
						speed: Number(this.radioValue)
					}
					if (!this.timeEnd) return false
					if (value) {
						this.chassisTimer = setInterval(() => {
							control(ajaxPost).then(() => {})
						}, 300)
					} else {
						deControl(ajaxPost).then(() => {})
					}
					return
				}
				if (['04', '05', '06', '07'].includes(this.robotInfo.robotType)) {
					let direction = 0
					this.postionTop = this.postionTop ? this.postionTop : 0
					this.postionLeft = this.postionLeft ? this.postionLeft : 0
					if (value) {
						if (type == 1) {
							if (this.postionTop == 0) this.postionTop = 1
							else return false
						} else if (type == 3) {
							if (this.postionLeft == 0) this.postionLeft = 1
							else return false
						} else if (type == 4) {
							if (this.postionLeft == 0) this.postionLeft = 2
							else return false
						} else if (type == 2) {
							if (this.postionTop == 0) this.postionTop = 2
							else return false
						}
					} else {
						if (type == 1 || type == 2) {
							if (this.postionTop == 0) return false
							this.postionTop = 0
						} else if (type == 3 || type == 4) {
							if (this.postionLeft == 0) return false
							this.postionLeft = 0
						}
					}

					if (this.postionTop == 1) {
						if (this.postionLeft == 1) direction = 5
						else if (this.postionLeft == 2) direction = 6
						else direction = 1
					} else if (this.postionTop == 2) {
						if (this.postionLeft == 1) direction = 8
						else if (this.postionLeft == 2) direction = 7
						else direction = 2
					} else if (this.postionTop == 0) {
						if (this.postionLeft == 1) direction = 3
						else if (this.postionLeft == 2) direction = 4
						else direction = 0
					}
					let ajaxPost = {
						number: this.robotInfo.number,
						direction,
						terminal: '1',
						speed: Number(this.radioValue)
					}
					if (!this.timeEnd) return false
					if (direction != '0') {
						this.chassisTimer = setInterval(() => {
							control(ajaxPost).then(() => {})
						}, 300)
					} else {
						control(ajaxPost).then(() => {})
					}
				}
			}
		},
		watch: {
			connected(val) {
				if (!val) this.releaseAll()
			},
			ifPTZTop(val) {
				this.pTZImg_t = val ? this.pTZImg_top_check : this.pTZImg_top
				this.ptzAngle('1', val)
			},
			ifPTZLeft(val) {
				this.pTZImg_l = val ? this.pTZImg_left_check : this.pTZImg_left
				this.ptzAngle('2', val)
			},
			ifPTZRight(val) {
				this.pTZImg_r = val ? this.pTZImg_right_check : this.pTZImg_right
				this.ptzAngle('3', val)
			},
			ifPTZBottom(val) {
				this.pTZImg_b = val ? this.pTZImg_bottom_check : this.pTZImg_bottom
				this.ptzAngle('4', val)
			},
			ifRodTop(val) {
				this.rodImg_t = val ? this.pTZImg_top_check : this.pTZImg_top
				this.rodAngle('1', val)
			},
			ifRodBottom(val) {
				this.rodImg_b = val ? this.pTZImg_bottom_check : this.pTZImg_bottom
				this.rodAngle('2', val)
			},
			ifpositionTop(val) {
				this.positionImg_t = val ? this.positionImg_top_check : this.positionImg_top
				this.chassisMove(1, val)
			},
			ifpositionLeft(val) {
				this.positionImg_l = val ? this.positionImg_left_check : this.positionImg_left
				this.chassisMove(3, val)
			},
			ifpositionRight(val) {
				this.positionImg_r = val ? this.positionImg_right_check : this.positionImg_right
				this.chassisMove(4, val)
			},
			ifpositionBottom(val) {
				this.positionImg_b = val ? this.positionImg_bottom_check : this.positionImg_bottom
				this.chassisMove(2, val)
			}
		}
	}
</script>

<style scoped lang="less">
	@import "../page/robotDetail/index/detail.less";

	.fireDom {
		position: relative;
	}

	.fireCount {
		font-size: 1.1vw;
		font-weight: 800;
		color: #00e8ff;
		text-shadow: 0 0 8px rgba(0, 240, 255, 0.4);
		letter-spacing: 1px;
	}

	.fireCountWarn {
		color: #ff6b7a;
		text-shadow: 0 0 8px rgba(255, 80, 100, 0.4);
	}

	.fireTabs {
		display: flex;
		justify-content: center;
		gap: 0.6vw;
		margin: 0.4vw 0 0.2vw;
	}

	.fireTab {
		padding: 0.25vw 1.2vw;
		font-size: 0.75vw;
		border: 1px solid rgba(0, 240, 255, 0.2);
		border-radius: 4px;
		cursor: pointer;
		color: #b0e0ff;
		transition: all 0.3s ease;

		&:hover {
			border-color: rgba(0, 240, 255, 0.4);
		}
	}

	.fireTabDo {
		background: linear-gradient(135deg, rgba(0, 100, 220, 0.7), rgba(0, 180, 255, 0.5));
		color: #ffffff;
		border-color: rgba(0, 240, 255, 0.4);
	}

	.fireInfo {
		padding: 0.4vw 0.8vw 0.8vw;
		text-align: left;
	}

	.fireRow {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.28vw 0;
		font-size: 0.75vw;
		border-bottom: 1px dashed rgba(0, 240, 255, 0.08);
	}

	.fireLabel {
		color: rgba(180, 220, 255, 0.65);
	}

	.fireValue {
		color: #e0f0ff;
		max-width: 12vw;
		word-break: break-all;
	}

	.fireImgDom {
		display: flex;
		justify-content: space-between;
		gap: 0.5vw;
		margin: 0.6vw 0;
	}

	.fireImg {
		width: 50%;

		img {
			width: 100%;
			height: 5vw;
			object-fit: cover;
			border: 1px solid rgba(0, 240, 255, 0.2);
			border-radius: 4px;
		}
	}

	.fireNoImg {
		width: 100%;
		height: 5vw;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.7vw;
		color: rgba(180, 220, 255, 0.45);
		border: 1px dashed rgba(0, 240, 255, 0.2);
		border-radius: 4px;
	}

	.fireImgName {
		font-size: 0.7vw;
		color: rgba(180, 220, 255, 0.65);
		text-align: center;
		margin-top: 0.2vw;
	}

	.fireApplied {
		margin-top: 0.6vw;
		padding: 0.4vw 0.6vw;
		font-size: 0.7vw;
		color: #b0e0ff;
		background: rgba(0, 40, 100, 0.4);
		border-left: 2px solid rgba(0, 240, 255, 0.5);
		border-radius: 0 4px 4px 0;
	}

	.fireState {
		margin-top: 0.4vw;
		font-size: 0.72vw;
		color: #ff6b7a;
		text-align: center;
	}

	.fireBtnDom {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 0.8vw;
	}

	.btnDis {
		opacity: 0.35;
		cursor: not-allowed;
		pointer-events: none;
	}

	.fireCtrl {
		padding: 0.4vw 0.8vw 0.8vw;
	}

	.fireCtrlTip {
		font-size: 0.7vw;
		color: #ff6b7a;
		text-align: center;
		margin-bottom: 0.3vw;
	}

	.fireCtrlBox {
		background: #122279;
		border-radius: 8px;
		margin-bottom: 0.6vw;
		padding-bottom: 0.4vw;
	}

	.fireCtrlBody {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 0.8vw;
	}

	.fireCtrlPad {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.fireCtrlImgL {
		width: 2.6vw;
		cursor: pointer;
	}

	.fireCtrlImgS {
		width: 1.6vw;
		margin: 0 0.3vw;
		cursor: pointer;
	}

	.fireCtrlName {
		font-size: 0.68vw;
		color: rgba(180, 220, 255, 0.6);
		max-width: 6vw;
		text-align: center;
	}

	.fireCtrlBtn {
		font-size: 0.72vw;
		padding: 0.3vw 0.8vw;
		background: linear-gradient(135deg, rgba(0, 100, 220, 0.7), rgba(0, 180, 255, 0.5));
		border: 1px solid rgba(0, 240, 255, 0.3);
		border-radius: 4px;
		cursor: pointer;
	}

	.fireCtrlSpeed {
		display: flex;
		flex-direction: column;
	}
</style>



// WEBPACK FOOTER //
// src/components/FirefightingDialog.vue